export const RUNGS = ['local-fixo', 'local-celular', 'ddd-fixo', 'ddd-celular', 'internacional'];

export const PRIVILEGE_OPTIONS = [
  { value: 'interno', label: 'Chamadas Internas' },
  { value: 'local-fixo', label: 'Chamadas Local Fixo' },
  { value: 'local-celular', label: 'Chamadas Local Celular' },
  { value: 'ddd-fixo', label: 'Chamadas DDD Fixo' },
  { value: 'ddd-celular', label: 'Chamadas DDD Celular' },
  { value: 'internacional', label: 'Internacional' }
];

const SLUG_PATTERN = '[a-z0-9]{2,8}';

export const privilegeSupportsGroup = (privilege) => RUNGS.includes(privilege);

const escapeForRegex = (value) => String(value == null ? '' : value).replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

export const parseEndpointContext = (context, tenant) => {
  const value = String(context == null ? '' : context);
  if (!tenant) return { privilege: value, group: '' };

  const grouped = value.match(new RegExp(`^(${RUNGS.join('|')})-${escapeForRegex(tenant)}-(${SLUG_PATTERN})$`));
  if (grouped) return { privilege: grouped[1], group: grouped[2] };

  let privilege = value;
  if (privilege.endsWith(`-${tenant}`)) privilege = privilege.slice(0, privilege.length - tenant.length - 1);
  if (privilege === 'from-extensions') privilege = 'interno';

  return { privilege, group: '' };
};

export const composeEndpointContext = (privilege, tenant, group) => {
  if (!privilege || !tenant) return privilege;
  if (group && privilegeSupportsGroup(privilege)) return `${privilege}-${tenant}-${group}`;
  return `${privilege}-${tenant}`;
};
